Monitoring.Views ||= {}

class Monitoring.Views.MovistarIntervalEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_interval_edit_modal"]

  events:
    'click #cancel-interval': 'onClickCancel'
    'click #save-interval': 'onClickSave'
    'change #interval-has-advance-options': 'onChangeAdvanceOptions'
    'change #interval-active': 'onChangeIntervalActive'
    'change #interval-start-date': 'onChangeStartDate'
    'change #interval-start-date-at': 'onChangeStartDate'
    'change #interval-end-date': 'onChangeEndDate'
    'change #interval-end-date-at': 'onChangeEndDate'
    'changeDate .datepicker': 'hideDatePicker'

  initialize: (@options = {}) ->
    @interval = @options.interval


  render: ->
    @$el.html(@template())
    @initializeModal()
    @initializeToggle()
    @initializeDatepicker(@interval.get('start_date'), @interval.get('end_date'))
    @updateSaveButtonStatus()
    @weekdaysCalendar = new Monitoring.Views.WeekdaysCalendarView(interval: @interval, el: @$el.find('.interval-advanced-options'))
    @weekdaysCalendar.fetchAndRender()
    @onChangeAdvanceOptions()
    @

  initializeModal: ->
    @$el.find('#interval-edit-modal').modal()

  initializeToggle: ->
    @$el.find('#interval-has-advance-options').bootstrapToggle({
      onstyle: 'success'
      offstyle: 'warning'
    })
    @$el.find('#interval-has-advance-options').bootstrapToggle('on') if @interval.get('has_advance_options')
    @$el.find('#interval-active').bootstrapToggle({
      onstyle: 'success'
      offstyle: 'warning'
    })
    @$el.find('#interval-active').bootstrapToggle('on') if @interval.get('active')

  initializeDatepicker: (startDate, endDate) ->
    @consistentDate(startDate, endDate)
    @$el.find('#interval-start-date').datepicker
      todayBtn: 'linked',
      autoclose: true
    @$el.find('#interval-start-date-at').modifiedwickedpicker(
      twentyFour: true,
      now: @timeFromDate(startDate, moment().format('HH:mm'))
    )
    @$el.find('#interval-end-date').datepicker
      autoclose: true
    if startDate
      @$el.find('#interval-start-date').datepicker('setDate', new Date(startDate))
    if endDate
      @$el.find('#interval-end-date').datepicker('setDate', new Date(endDate))
      @$el.find('#interval-end-date-at').modifiedwickedpicker(
        twentyFour: true,
        now: @timeFromDate(endDate, moment().format('HH:mm'))
      )
    else
      @$el.find('#interval-end-date-at').modifiedwickedpicker(
        twentyFour: true,
        now: '23:59'
      )
      @hideEndDateAt()

  onChangeAdvanceOptions: (evt) ->
    hasAdvanceOptions = @$el.find('#interval-has-advance-options').prop('checked')
    @interval.set('has_advance_options', hasAdvanceOptions)
    if hasAdvanceOptions
      @$el.find('.interval-advanced-options').css('display', 'block')
    else
      @$el.find('.interval-advanced-options').css('display', 'none')

  onChangeIntervalActive: (evt) ->
    active = @$el.find('#interval-active').prop('checked')
    @interval.set('active', active)

  onChangeStartDate: (evt) ->
    #Unreliable: This is called many times due to wickedpicker
    startDate = @completeDate("start")
    @consistentDate(startDate, @completeDate("end"))
    @interval.set('start_date', startDate)
    @updateSaveButtonStatus()

  onChangeEndDate: (evt) ->
    #Unreliable: This is called many times due to wickedpicker
    @checkEndTime()
    endDate = @completeDate("end")
    @consistentDate(@completeDate("start"), endDate)
    @interval.set('end_date', endDate)
    @updateSaveButtonStatus()

  completeDate: (type) ->
    date = @$el.find("#interval-#{type}-date").datepicker("getDate")
    time = @$el.find("#interval-#{type}-date-at").val().replace(/\s+/g, '') || "00:00"
    unless date == undefined or date == null
      date.setHours(time.split(":")[0])
      date.setMinutes(time.split(":")[1])
    date

  timeFromDate: (date, default_time) ->
    return default_time if date == undefined or date == null
    Date.create(date).format('HH:mm')

  checkEndTime: ->
    if @$el.find("#interval-end-date").datepicker("getDate")
      @showEndDateAt()
    else
      @hideEndDateAt()

  hideDatePicker: ->
    @$el.find('#interval-end-date').datepicker('hide')

  consistentDate: (from, to) ->
    if (from == undefined or to == undefined) or (from == null or to == null)
      return true
    consistent = true
    if (from > to)
      @$el.find('#interval-start-date').css('background-color','#eb8f8f')
      @$el.find('#interval-end-date').css('background-color','#eb8f8f')
      consistent = false
    @changeDatePickerColor(consistent)
    return consistent

  updateSaveButtonStatus: =>
    @$el.find('#save-interval').prop('disabled', !@allMandatoryFieldsAreFilled())

  allMandatoryFieldsAreFilled: =>
    @startDateIsFilled() and @datesAreConsistent()

  startDateIsFilled: ->
    @$el.find('#interval-start-date').val().trim().length > 0

  changeDatePickerColor:(valid) ->
    if valid
      @$el.find('#interval-start-date').css('background-color','#f1f1f1')
      @$el.find('#interval-end-date').css('background-color','#f1f1f1')
      @$el.find('#interval-start-date-at').css('background-color','#f1f1f1')
      @$el.find('#interval-end-date-at').css('background-color','#f1f1f1')
    else
      @$el.find('#interval-start-date').css('background-color','#eb8f8f')
      @$el.find('#interval-end-date').css('background-color','#eb8f8f')
      @$el.find('#interval-start-date-at').css('background-color','#eb8f8f')
      @$el.find('#interval-end-date-at').css('background-color','#eb8f8f')

  datesAreConsistent: ->
    from = @completeDate("start")
    to = @completeDate("end")
    @consistentDate(from, to)

  showEndDateAt: ->
    @$el.find('#interval-end-date-at').prop('disabled', false)
    @$el.find('#interval-end-date-at').show()
    @$el.find('#end-date-at-icon').show()

  hideEndDateAt: ->
    @$el.find('#interval-end-date-at').prop('disabled', true)
    @$el.find('#interval-end-date-at').hide()
    @$el.find('#end-date-at-icon').hide()

  onClickCancel: ->
    @$el.find('#interval-edit-modal').modal('hide')

  onClickSave: (evt) ->
    $(evt.currentTarget).button('loading')
    @$el.find('.saving').removeClass('invalid-fields')
    if @allMandatoryFieldsAreFilled()
      # i dont know why getSerialization returns a string instead of an object but...
      weekdays = JSON.parse(@weekdaysCalendar.getSerialization())
      @interval.set('work_calendar_settings', weekdays)
      @$el.find('#interval-edit-modal').modal('hide')
      @trigger('afterSaveInterval', @interval)
    else
      @$el.find('.saving').html('Error')
